import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

interface MarketingRevenueMonth {
  month: string;
  adRevenue: number;
  revenueProtected: number;
  [key: string]: unknown;
}

export interface MarketingMonthlyRevenueResponse {
  months: MarketingRevenueMonth[];
  [key: string]: unknown;
}

export function useMarketingMonthlyRevenue(
  userId: string,
  startDate: string,
  endDate: string,
  enabled = true,
) {
  const query = useQuery<MarketingMonthlyRevenueResponse>({
    queryKey: ["marketing-monthly-revenue", userId, startDate, endDate],
    queryFn: () =>
      api.marketing.monthlyRevenue.get(userId, { startDate, endDate }) as Promise<MarketingMonthlyRevenueResponse>,
    enabled: !!userId && !!startDate && !!endDate && enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    // v4.5.0 returns isLoading:true for disabled queries with no cache.
    // Override so consumers only see loading while actually fetching.
    isLoading: query.isLoading && query.isFetching,
  };
}
